module.exports = __webpack_public_path__ + "img/pledge.1a36ba9b.jpg";